import { render, staticRenderFns } from "./VReportTable.vue?vue&type=template&id=3b5567f8"
import script from "./VReportTable.vue?vue&type=script&lang=js"
export * from "./VReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports